(function () {
  /**
   * Reads the sale price and full (original) price from the currently selected
   * Rapi bundle bar. Rapi updates .rapi-bundles__bar-price when a subscription
   * option is chosen, so this always reflects the true final price.
   * Returns { salePrice, fullPrice } or null if Rapi hasn't rendered yet.
   */
  function getSelectedRapiPrices() {
    var checkedInput = document.querySelector('.rapi-bundles__bar input:checked');
    if (!checkedInput) return null;

    var bar = checkedInput.closest('.rapi-bundles__bar');
    if (!bar) return null;

    var saleEl = bar.querySelector('.rapi-bundles__bar-price .rapi-money');
    var fullEl = bar.querySelector('.rapi-bundles__bar-full-price .rapi-money');

    var salePrice = saleEl ? saleEl.textContent.trim() : null;
    var fullPrice = fullEl ? fullEl.textContent.trim() : null;

    if (!salePrice) return null;

    return { salePrice: salePrice, fullPrice: fullPrice };
  }

  function updateButtonPrices(prices) {
    document.querySelectorAll('.add-to-cart__sale-price').forEach(function (el) {
      el.textContent = prices.salePrice;
    });

    document.querySelectorAll('.add-to-cart__full-price').forEach(function (el) {
      // Only show strikethrough when full price differs from sale price
      if (prices.fullPrice && prices.fullPrice !== prices.salePrice) {
        el.textContent = prices.fullPrice;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }

  function isSubscriptionSelected() {
    // Both purchase options use .rapi-subscription__bar; the subscription bar
    // is identified by the presence of .rapi-bundles__bar-variant-selects (the
    // frequency dropdown). One-time purchase bars don't have it.
    var checkedInput = document.querySelector('.rapi-subscription__bar input:checked');
    if (!checkedInput) return false;
    var bar = checkedInput.closest('.rapi-subscription__bar');
    return bar ? !!bar.querySelector('.rapi-bundles__bar-variant-selects') : false;
  }

  function updateButtonLabel() {
    var label = isSubscriptionSelected() ? 'Subscribe Now' : 'Add to Cart';
    document.querySelectorAll('.add-to-cart__label').forEach(function (el) {
      el.textContent = label;
    });
  }

  function syncPrices() {
    var prices = getSelectedRapiPrices();
    if (prices) updateButtonPrices(prices);
    updateButtonLabel();
  }

  // Rapi's bundle radios have readonly="" and are checked programmatically,
  // so no native `change` event fires. Use `click` on the bar labels as a
  // fallback, but the MutationObserver below is the primary sync mechanism.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.rapi-bundles__bar, .rapi-subscription__bar')) return;
    // Rapi updates its own price display asynchronously after the click.
    // The MutationObserver will catch it, but the click handler ensures we
    // also handle any cases where Rapi doesn't trigger a DOM mutation.
    setTimeout(syncPrices, 150);
  });

  /**
   * Starts a MutationObserver on the Rapi bundle container that calls
   * syncPrices whenever price text inside any .rapi-bundles__bar-price or
   * .rapi-bundles__bar-full-price node changes. This catches subscription
   * frequency changes and any other Rapi-driven price updates.
   */
  function startRapiPriceObserver() {
    var container = document.querySelector('.rapi-bundles') || document.body;
    var debounceTimer;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var node = mutations[i].target;
        // Price text changed
        var isPriceNode = (
          node.nodeType === Node.TEXT_NODE
            ? node.parentElement && node.parentElement.closest('.rapi-bundles__bar-price, .rapi-bundles__bar-full-price')
            : node.closest && node.closest('.rapi-bundles__bar-price, .rapi-bundles__bar-full-price')
        );
        // Subscription bar checked state changed (attribute mutation on the input)
        var isSubscriptionToggle = (
          mutations[i].type === 'attributes' &&
          mutations[i].attributeName === 'checked' &&
          node.closest && node.closest('.rapi-subscription__bar')
        );
        if (isPriceNode || isSubscriptionToggle) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(syncPrices, 50);
          break;
        }
      }
    });
    observer.observe(container, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['checked'] });
  }

  /**
   * Injects HTML markup into the Rapi widget.
   * @param {string} html - The HTML string to inject.
   * @param {string|Element} parent - A CSS selector string or DOM element to append into.
   * @param {Object} [options]
   * @param {string} [options.position='beforeend'] - InsertAdjacentHTML position:
   *   'beforebegin', 'afterbegin', 'beforeend', 'afterend'
   * @param {boolean} [options.replace=false] - If true, replaces existing innerHTML instead of appending.
   */
  function injectRapiHTML(html, parent, options) {
    var opts = Object.assign({ position: 'beforeend', replace: false }, options);
    var el = typeof parent === 'string' ? document.querySelector(parent) : parent;
    if (!el) {
      console.warn('[Rapi] injectRapiHTML: parent element not found:', parent);
      return;
    }
    if (opts.replace) {
      el.innerHTML = html;
    } else {
      el.insertAdjacentHTML(opts.position, html);
    }
  }

  /**
   * Returns the benefits HTML to inject. Tries to re-use the SVG icon from
   * an existing .subscription-benefit-icon already in the DOM (rendered by the
   * subscriptions snippet). Falls back to a plain ✓ character if not found.
   */
  function buildBenefitsHTML(discountPct) {
    var existingIcon = document.querySelector('.subscription-benefit-icon');
    var iconHTML = existingIcon
      ? existingIcon.innerHTML
      : '<span style="font-weight:bold;">&#10003;</span>';
    var pctLabel = discountPct ? "Extra " + discountPct + '% off subscriptions' : 'Subscriber discount';
    return (
      '<div class="subscription-benefits">' +
        '<div class="subscription-benefit">' +
          '<span class="subscription-benefit-icon">' + iconHTML + '</span>' +
          '<p>' + pctLabel + '</p>' +
        '</div>' +
        '<div class="subscription-benefit">' +
          '<span class="subscription-benefit-icon">' + iconHTML + '</span>' +
          '<p>Pause or cancel anytime</p>' +
        '</div>' +
      '</div>'
    );
  }

  /**
   * Injects subscription benefits between .rapi-subscription-title and
   * .rapi-subscription-subtitle inside every .rapi-subscription__bar.
   * Parses the discount % directly from the title text (e.g. "Subscribe & save 15%").
   */
  function injectSubscriptionBenefits() {
    document.querySelectorAll('.rapi-subscription__bar').forEach(function (bar) {
      if (bar.querySelector('.subscription-benefits')) return;

      var title = bar.querySelector('.rapi-subscription-title');
      if (!title) return;

      // Only inject on subscription bars — identified by the frequency select element.
      // One-time purchase bars don't have .rapi-bundles__bar-variant-selects.
      if (!bar.querySelector('.rapi-bundles__bar-variant-selects')) return;

      var match = title.textContent.match(/(\d+)%/);
      var discountPct = match ? match[1] : null;

      injectRapiHTML(buildBenefitsHTML(discountPct), title, { position: 'afterend' });
    });
  }

  /**
   * Injects custom HTML into .rapi-header-title (the Rapi widget header).
   */
  function injectRapiHeader() {
    var header = document.querySelector('.rapi-header-title');
    if (!header) return;
    if (header.querySelector('.horizontal-heading')) return;
    injectRapiHTML(
      '<div class="horizontal-heading"><span>Quantity</span></div>',
      header,
      { position: 'beforeend' }
    );
  }

  /**
   * Watches for a selector to appear in the DOM, then runs the callback once.
   * Disconnects after the callback fires, or after 15 s as a safety net.
   */
  function observeOnce(selector, callback) {
    if (document.querySelector(selector)) {
      callback();
      return;
    }
    var observer = new MutationObserver(function () {
      if (document.querySelector(selector)) {
        observer.disconnect();
        callback();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  function observeAndSyncRapi() {
    observeOnce('.rapi-bundles__bar', function () {
      syncPrices();
      startRapiPriceObserver();
    });
  }

  function observeAndInjectHeader() {
    observeOnce('.rapi-header-title', injectRapiHeader);
  }

  function observeAndInjectBenefits() {
    observeOnce('.rapi-subscription__bar .rapi-subscription-title', injectSubscriptionBenefits);
  }

  function styleRapiButton() {
    document.querySelectorAll('.rapi-pressable-button').forEach(function (btn) {
      btn.classList.remove('rapi-pressable-button')
      btn.classList.add('cta', 'primary-cta');
    });
  }

  function observeAndStyleButton() {
    // Run once for any buttons already in the DOM.
    styleRapiButton();
    // Then watch persistently so buttons added later (e.g. modals) are also styled.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.classList.contains('rapi-pressable-button') || node.querySelector('.rapi-pressable-button')) {
            styleRapiButton();
            break;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Expose for use in other scripts / theme sections
  window.rapiUtils = window.rapiUtils || {};
  window.rapiUtils.injectHTML = injectRapiHTML;
  window.rapiUtils.injectSubscriptionBenefits = injectSubscriptionBenefits;
  window.rapiUtils.injectRapiHeader = injectRapiHeader;

  document.addEventListener('DOMContentLoaded', function () {
    observeAndSyncRapi();
    observeAndInjectHeader();
    observeAndInjectBenefits();
    observeAndStyleButton();
  });
})();
